module.exports = __webpack_public_path__ + "static/img/bear.4b4b0bc1.png";